
import Vue from "vue";
import Component from "vue-class-component";
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import { DuplicableDocumentModel, DuplicableDocumentModelDocumentType, StartApplyingOrChangeTypeClient } from "@/api-client";
import { Prop } from "vue-property-decorator";
import userInfo from "@/features/shared/components/UserInfo";
import { NavigationGuardNext } from "vue-router/types/router";
import DuplicateTypeTable from "../components/DuplicateTypeTable.vue";

interface Props {
    documentType?: DuplicableDocumentModelDocumentType | null;
    seafarerId: string;
    duplicableDocuments: DuplicableDocumentModel[];
}

@Component({
    components: {
        HeadingWave,
        SectionPageHeading,
        DuplicateTypeTable
    },
    beforeRouteEnter(to, from, next: NavigationGuardNext<NewDuplicate>) {
        const props = to.meta!.props as Props;
        props.seafarerId = to.params.seafarerId || userInfo.seafarerId;
        if (!props.seafarerId)
            next(new Error("No seafarer."));

        Promise.all([
            new StartApplyingOrChangeTypeClient().duplicableDocuments(props.seafarerId)
        ]).then(values => {
            props.duplicableDocuments = values[0];
            next();
        }).catch(e => next(e))
    }
})
export default class NewDuplicate extends Vue implements Props {
    @Prop({ required: false, default: null })
    documentType!: DuplicableDocumentModelDocumentType | null;
    @Prop({ required: true })
    seafarerId!: string;
    @Prop({ required: true })
    duplicableDocuments!: DuplicableDocumentModel[];
}
